import React from 'react';

export const lpContext = React.createContext();
const { Provider } = lpContext;

export default function TemplatesProvider({ children, value, ...props }) {
  return <Provider value={value}>{children}</Provider>;
}
